import React from 'react'
import { SectionPlaceholder } from 'src/components'
import { PortfolioCard } from './components'
import { MenuLinks, PortfolioContent } from 'src/content'
import { Stack } from '@mantine/core'

export interface PortfolioProps {}

export const Portfolio: React.FC<PortfolioProps> = () => {
  const { Portfolio: portfolios } = PortfolioContent
  const { MenuAnchor } = MenuLinks

  return (
    <SectionPlaceholder
      title="Portfolio"
      subTitle='res.status(200).send("Projects");'
      anchorClassName={MenuAnchor.Portfolio}
    >
      <Stack
        spacing={'xl'}
        mt={'md'}
        sx={{
          alignItems: 'center',
        }}
      >
        {portfolios.length && portfolios.map(portfolio => <PortfolioCard key={portfolio.name} {...portfolio} />)}
      </Stack>
    </SectionPlaceholder>
  )
}
